<template>
  <main class="payment-result-page" dir="rtl">
    <section class="payment-result-card" :class="isSuccess ? 'is-success' : 'is-failure'">
      <div class="result-icon" aria-hidden="true">{{ isSuccess ? '✓' : '×' }}</div>
      <h1>{{ isSuccess ? 'پرداخت موفق بود' : 'پرداخت ناموفق بود' }}</h1>
      <p class="result-message" role="status">{{ message }}</p>
      <p v-if="orderId" class="order-number">شماره سفارش: {{ orderId }}</p>
      <router-link class="dashboard-link" to="/dashboard">بازگشت به داشبورد</router-link>
    </section>
  </main>
</template>

<script>
export default {
  name: 'PaymentVerification',
  computed: {
    isSuccess() {
      return this.$route.query.gateway_status === 'success'
    },
    message() {
      return this.$route.query.gateway_message || (
        this.isSuccess ? 'پرداخت شما با موفقیت تأیید شد.' : 'پرداخت تأیید نشد. در صورت کسر وجه، با پشتیبانی تماس بگیرید.'
      )
    },
    orderId() {
      return this.$route.query.order_id || ''
    },
  },
}
</script>

<style scoped>
.payment-result-page {
  min-height: 100vh;
  display: grid;
  place-items: center;
  padding: 24px;
  background: var(--bg, #f4f6f8);
  color: var(--text, #20252b);
}
.payment-result-card {
  width: min(100%, 480px);
  padding: 32px;
  border: 1px solid var(--border, #dfe3e8);
  border-radius: 16px;
  background: var(--card-bg, #fff);
  text-align: center;
  box-shadow: var(--shadow, 0 12px 32px rgb(0 0 0 / 8%));
}
.result-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 16px;
  border-radius: 50%;
  font-size: 42px;
  line-height: 64px;
  font-weight: 700;
}
.is-success .result-icon { color: #167343; background: #e6f6ed; }
.is-failure .result-icon { color: #a33232; background: #fdeaea; }
h1 { margin: 0 0 12px; font-size: 1.5rem; }
.result-message { line-height: 1.9; }
.order-number { color: #626b75; font-size: .9rem; }
.dashboard-link {
  display: inline-block;
  margin-top: 12px;
  padding: 10px 18px;
  border-radius: 8px;
  background: var(--primary, #0876d1);
  color: #fff;
  text-decoration: none;
}
</style>
